export enum ShipmentStatus {
  Open = 'Open',
  InProgress = 'InProgress',
  Closed = 'Closed'
};
